import { api } from '@/lib/api/client';

export type LegalDocumentType =
  | 'platform_tos'
  | 'platform_privacy'
  | 'data_controller_ack'
  | 'dpa'
  | 'tcpa'
  | 'reporter_terms'
  /*
   * Los reconocimientos del representante (Exhibit F, migración 119). Llevan
   * `payload` con la foto de lo reconocido y exigen nombre y cargo.
   */
  | 'legal_setup_ack'
  | 'data_export_ack'
  | 'media_adopt_generic_ack'
  | 'standard_tier_ack';

export interface LegalAcceptance {
  id: number;
  documentType: LegalDocumentType;
  documentVersion: string;
  versionHash: string;
  brandId: number | null;
  signerName: string | null;
  signerTitle: string | null;
  locale: string;
  acceptedAt: string;
  userId?: number;
  payload?: Record<string, unknown> | null;
}

export const legalApi = {
  check: (
    documentType: LegalDocumentType,
    versionHash: string,
    brandId?: number,
  ) =>
    api.get<LegalAcceptance | null>('/co-legal-acceptance/check', {
      params: { documentType, versionHash, brandId },
    }),

  mine: () => api.get<LegalAcceptance[]>('/co-legal-acceptance/mine'),

  record: (input: {
    documentType: LegalDocumentType;
    /** Para los reconocimientos (Exhibit F) los calcula el backend sobre `payload`. */
    documentVersion?: string;
    versionHash?: string;
    brandId?: number;
    signerName?: string;
    signerTitle?: string;
    locale?: string;
    /** La foto de lo reconocido: configuración legal o descriptor del export. */
    payload?: Record<string, unknown>;
  }) => api.post<LegalAcceptance>('/co-legal-acceptance', input),

  /** El historial de una marca: reconocimientos, DPA, Data Controller… (más reciente primero). */
  forBrand: (brandId: number) =>
    api.get<LegalAcceptance[]>(`/co-legal-acceptance/brand/${brandId}`),
};
